import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE } from '../../models/constants';

@Component({
  selector: 'ca-crm-icon',
  templateUrl: './crm-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CrmIconComponent {
  localizationScope = PROFILE_COMPONENTS_COMMON_LOCALIZATION_SCOPE;

  @Input() iconClass: string = 'ms-1 align-bottom';
  @Input() iconSizeClass: string = 'f-i-sm';
  @Input() container: string = 'target';
}
